// import React from 'react'
// import { Link } from 'react-router-dom'

// const PageTitle = (props) => {
//     return(
//         <section className="wpo-page-title">
//             <div className="container">
//                 <div className="row">
//                     <div className="col col-xs-12">
//                         <div className="wpo-breadcumb-wrap">
//                             <h2>{props.pageTitle}</h2>
//                             <ol className="wpo-breadcumb-wrap">
//                                 <li><Link to="/">Home</Link></li>
//                                 <li><span>{props.pagesub}</span></li>
//                             </ol>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     )
// }

// export default PageTitle;






import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getPageTitleImage } from '../../api/PageTitle';  // Correct path

const PageTitle = (props) => {
    const [backgroundImage, setBackgroundImage] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchImage = async () => {
            try {
                const data = await getPageTitleImage();
                if (data && data.length > 0) {
                    setBackgroundImage(data[0].image);
                }
            } catch (error) {
                console.error('Failed to fetch page title image:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchImage();
    }, []);

    const sectionStyle = {
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center top',
        backgroundSize: 'cover',
    };

    if (loading) {
        return null; // Or return a loader component
    }

    return (
        <section className="wpo-page-title" style={sectionStyle}>
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="wpo-breadcumb-wrap">
                            <h2>{props.pageTitle}</h2>
                            <ol className="wpo-breadcumb-wrap">
                                <li><Link to="/">Home</Link></li>
                                <li><span>{props.pagesub}</span></li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PageTitle;